<template>
    <section class="memberQualification">
        <div :style="`z-index: 250; position: fixed; right: 7%; top: ${screen_width >= 1265 ? '13px' : '80px;'}`">
            <v-alert
                v-model="notif.show"
                transition="scroll-x-reverse-transition"
                :type="notif.type"
                :color="notif.color"
                :dismissible="notif.dismissible"
            >
                {{ notif.msg }}
            </v-alert>
        </div>
        <h1 style="margin: 0 auto;">
            <v-icon
                v-if="screen_width > 390"
                x-large
                elevation="10"
                class="white--text"
                style="height: 50px; width: 50px; background-color: #009688; border-radius: 25px; margin-right: 2%;"
            >
                {{ mdiGroup }}
            </v-icon>
            <span>Groups</span>
        </h1>
        <v-card elevation="10" class="acuGroupBody">
            <v-data-table
                class="msuGroupTbl"
                :items="listMsuGroupsData && listMsuGroupsData.data ? listMsuGroupsData.data : []"
                :headers="headers"
                :loading="loading.index"
                :search="search.query"
            >
                <template #top>
                    <v-card-title>
                        <v-row>
                            <v-col cols="10">
                                <v-text-field
                                    v-model="search.value"
                                    outlined
                                    style="width: 100%;"
                                    placeholder="Search ..."
                                    hide-details
                                    dense
                                    clearable
                                    :append-icon="mdiMagnify"
                                    color="teal"
                                    @click:clear="search.query = null"
                                    @keydown.enter.prevent="search.query = search.value"
                                    @click:append="search.query = search.value"
                                />
                            </v-col>
                            <v-col cols="2">
                                <v-btn
                                    color="success"
                                    style="width: 100%;"
                                    @click="handleNewGroup"
                                >
                                    <v-icon>{{ mdiPlus }}</v-icon> New
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-title>
                </template>
                <template #item="{ item, index }">
                    <tr
                        @mouseenter="hoveredRow = index"
                        @mouseleave="hoveredRow = null"
                    >
                        <td
                            v-for="header in headers"
                            :key="header.value"
                            :style="{ backgroundColor: hoveredRow === index ? '#EEE' : 'white', textAlign: ['ACTIONS'].includes(header.value) ? 'center' : '' }"
                        >
                            <span style="text-wrap: nowrap;">
                                <template v-if="header.value === 'MODIFIED_ON'">
                                    {{ formatDate(item.MODIFIED_ON) }}
                                </template>
                                <template v-else-if="header.value === 'ACTIONS'">
                                    <v-tooltip top>
                                        <template #activator="{ on }">
                                            <v-btn
                                                icon
                                                color="primary"
                                                :loading="loading.msuGroup && loading.id === item.MSUGRP_ID"
                                                v-on="on"
                                                @click="showMsuGroup(item)"
                                            >
                                                <v-icon>{{ mdiEye }}</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Show MSU Group</span>
                                    </v-tooltip>
                                    <v-tooltip top>
                                        <template #activator="{ on }">
                                            <v-btn
                                                icon
                                                color="primary"
                                                v-on="on"
                                                @click="showHistory(item)"
                                            >
                                                <v-icon>{{ mdiFileEye }}</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Show History</span>
                                    </v-tooltip>
                                    <v-tooltip top>
                                        <template #activator="{ on }">
                                            <v-btn
                                                icon
                                                color="warning"
                                                v-on="on"
                                                @click="editMsuGroup(item)"
                                            >
                                                <v-icon>{{ mdiPencil }}</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Edit Group Name</span>
                                    </v-tooltip>
                                    <v-tooltip top>
                                        <template #activator="{ on }">
                                            <v-btn
                                                icon
                                                color="error"
                                                v-on="on"
                                                @click="deleteMsuGroup(item)"
                                            >
                                                <v-icon>{{ mdiTrashCan }}</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Delete Group</span>
                                    </v-tooltip>
                                </template>
                                <template v-else>
                                    {{ item[header.value] }}
                                </template>
                            </span>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-card>
        <ShowHistory
            :show="show.history.status"
            :data="show.history.value"
            @closeDialog="show.history.status = false"
        />
        <UpdateGroup
            :show="show.edit.status"
            :data="show.edit.value"
            :notif="notif"
            @closeDialog="show.edit.status = false"
        />
        <DeleteGroup
            :show="show.delete.status"
            :data="show.delete.value"
            :notif="notif"
            @closeDialog="show.delete.status = false"
        />
        <MsuList
            :show="show.msuGroup.status"
            :data="show.msuGroup.value"
            :notif="notif"
            @closeDialog="handleCloseMsuList"
        />
        <NewGroup
            :show="show.new.status"
            :notif="notif"
            @closeDialog="handleCloseNewGroup"
        />
    </section>
</template>

<script>
import NewGroup from './NewGroup.vue'
import MsuList from './MsuList/IndexPage.vue'
import DeleteGroup from './DeleteGroup.vue'
import UpdateGroup from './UpdateGroup.vue'
import ShowHistory from './ShowHistory.vue'
import { mapActions, mapGetters } from 'vuex'
import {
    mdiGroup,
    mdiMagnify,
    mdiPlus,
    mdiEye,
    mdiFileEye,
    mdiPencil,
    mdiTrashCan
} from '@mdi/js'
import { moment } from '../../../../../utils/date-shim'
export default {
    components: { ShowHistory, UpdateGroup, DeleteGroup, MsuList, NewGroup },
    data: ()=>({
        mdiGroup,
        mdiMagnify,
        mdiPlus,
        mdiEye,
        mdiFileEye,
        mdiPencil,
        mdiTrashCan,
        loading: {
            msuGroup: false,
            index: false,
            id: null
        },
        search: {
            value: null,
            query: null
        },
        show: {
            msuGroup: {
                value: {
                    msuInfo: null,
                    groupInfo: null
                },
                status: false,
                loadTemplate: false
            },
            history: { value: null, status: false },
            delete: { value: null, status: false },
            edit: { value: null, status: false },
            new: { value: null, status: false }
        },
        hoveredRow: null,
        headers: [
            { text: 'MSU Group ID', value: 'MSUGRP_ID' },
            { text: 'MSU Group Name', value: 'MSUGRP_NAME' },
            { text: 'Modified On', value: 'MODIFIED_ON' },
            { text: 'Modified By', value: 'MODIFIED_BY' },
            { text: 'Actions', value: 'ACTIONS', align: 'center', sortable: false }
        ],
        notif: {
            show: false,
            type: 'success',
            msg: 'Done',
            color: 'success',
            dismissible: false
        },
        screen_width: document.documentElement.clientWidth + 9
    }),
    computed: {
        ...mapGetters(['listMsuGroupsData', 'viewMsuGroupData'])
    },
    watch: {
        viewMsuGroupData(newVal) {
            this.show.msuGroup.value.groupInfo = newVal.data
        },
        'search.value'(newVal) {
            if (newVal === '') {
                this.search.query = null
            }
        },
        listMsuGroupsData() {
            this.loading.index = false
        },
        notif: {
            handler(newVal) {
                if (newVal.show) {
                    if (newVal.timeout !== 0) {
                        setTimeout(() => {
                            this.notif.show = false
                        }, newVal.timeout)
                    }
                }
            },
            deep: true
        }
    },
    mounted() {
        window.addEventListener('resize', this.onResize)
        this.loading.index = true
        this.listMsuGroups()
    },
    destroyed(){
        window.removeEventListener('resize', this.onResize)
    },
    methods: {
        ...mapActions(['listMsuGroups', 'viewMsuGroup']),
        handleNewGroup() {
            this.show.new.status = true
        },
        handleCloseNewGroup() {
            this.show.new.status = false
        },
        handleCloseMsuList() {
            this.show.msuGroup.value.groupInfo = null
            this.show.msuGroup.loadTemplate = false
            this.show.msuGroup.status = false
        },
        async showMsuGroup(data) {
            this.loading.id = data.MSUGRP_ID
            this.loading.msuGroup = true
            this.show.msuGroup.loadTemplate = true
            this.show.msuGroup.value.msuInfo = data
            await this.viewMsuGroup({ ID: data.MSUGRP_ID })
            this.loading.msuGroup = false
            if (this.viewMsuGroupData.status === 200) {
                if (this.show.msuGroup.loadTemplate) {
                    this.show.msuGroup.value.groupInfo = this.viewMsuGroupData.data
                    this.show.msuGroup.status = true
                }
            }
        },
        deleteMsuGroup(data) {
            this.show.delete.status = true
            this.show.delete.value = data
        },
        editMsuGroup(data) {
            this.show.edit.status = true
            this.show.edit.value = data
        },
        showHistory(data) {
            this.show.history.status = true
            this.show.history.value = data
        },
        formatDate(date) {
            return moment(date).utcOffset('+0800').format('MMMM DD, YYYY hh:mm A')
        },
        onResize() {
            this.screen_width = document.documentElement.clientWidth
            this.screen_width = this.screen_width + 9
        }
    }
}
</script>

<style>
.no-padding-header {
    padding: 0 !important;
}
.memberQualification h1 {
    position: relative;
    font-size: 25px;
    padding: 10px;
    border-bottom: 1px solid #bbb;
}
.memberQualification .acuGroupBody {
    margin-top: 2%;
}
.msuGroupTbl > div > table > thead > tr > th:nth-child(1) {
    width: 50px; /* You can adjust this width as needed */
    position: sticky !important;
    top: 0;
    left: 0;
    z-index: 5; /* Ensure the first column has a higher z-index */
    background: white;
}
.msuGroupTbl > div > table > tbody > tr > td:nth-child(1) {
    width: 50px; /* You can adjust this width as needed */
    position: sticky !important;
    left: 0;
    z-index: 2; /* Ensure the first column has a higher z-index */
    background: white;
}
.msuGroupTbl > div > table > thead > tr > th {
    width: 100px; /* You can adjust this width as needed */
    position: sticky !important;
    z-index: 2; /* Ensure the second column has a lower z-index than the first one */
    background: white;
    top: 0;
}
.msuGroupTbl > div > table > tbody > tr > td:last-child {
    width: 50px; /* You can adjust this width as needed */
    position: sticky !important;
    right: 0;
    z-index: 2; /* Ensure the first column has a higher z-index */
    background: white;
}
.msuGroupTbl > div > table > thead > tr > th:last-child {
    width: 50px; /* You can adjust this width as needed */
    position: sticky !important;
    top: 0;
    right: 0;
    z-index: 5; /* Ensure the first column has a higher z-index */
    background: white;
}
.msuGroupTbl .v-data-table__wrapper {
    max-height: 70vh; /* Adjust the height according to your needs */
    overflow-y: auto; /* Enable vertical scrolling */
}
</style>
